import { combineReducers } from '@reduxjs/toolkit';
import { createNewsSlice } from './model/createNews';
import { newsSlice } from './model/news';

const newsReducer = combineReducers({
  news: newsSlice.reducer,
  createNews: createNewsSlice.reducer,
});

export default newsReducer;
